import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateIncidentInput, ExtranetIncidentOutput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';

export const useCreateIncident = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateIncidentInput) =>
      getExtranetApi().post<CreateIncidentInput, ExtranetIncidentOutput>('/v1/extranet/incidents', input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['extranet', 'incidents'] });
      queryClient.invalidateQueries({ queryKey: ['extranet', 'dashboard', 'incident-category-buckets'] });
    },
  });
};
